module.exports = __webpack_public_path__ + "static/media/barcode-scan.0fe4a6b3.svg";